import { Box } from "@mui/material";
import { useState } from "react";
import Breeds from "../../ComingSoon/cards/Breeds";
import Species from "../../ComingSoon/cards/Species";

const PetMaster = () => {
  const [speciesSelected, setSpeciesSelected] = useState(false);
  const [selectedSpeciesId, setSelectedSpeciesId] = useState(null);

  return (
    <Box sx={{ padding: "20px" }}>
      {speciesSelected ? (
        <Breeds
          speciesId={selectedSpeciesId}
          onBack={() => setSpeciesSelected(false)}
        />
      ) : (
        <Species
          onSpeciesClick={(id) => {
            setSelectedSpeciesId(id);
            setSpeciesSelected(true);
          }}
        />
      )}
    </Box>
  );
};

export default PetMaster;
